<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <div id="select-class-page" class="qi-content">
        <header>
          <h1>Turmas</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row vs-justify="left">
          <SelectedCourseBox></SelectedCourseBox>
          <SelectedOfferBox></SelectedOfferBox>
        </vs-row>
        <h3 style="margin-bottom: 10px">Selecione uma Turma</h3>
        <vs-row vs-justify="left">
          <vs-col
            vs-w="12"
            :key="classData.IDTURMADISC"
            v-for="classData in classes"
          >
            <div
              style="border-radius:10px;"
              :style="critical(classData.PERCTURMACRITICA)"
              @click="selectClass(classData)"
            >
              <vs-card class="choosable-card">
                <div class="no-flex" slot="header">
                  <h4 class="text-center">Turma: {{ classData.NOMETURMA }}</h4>
                  <span
                    style="font-weight: bold; color: #FF0000;"
                    v-if="classData.PERCTURMACRITICA != '0.00'"
                  >
                    Turma Crítica: desconto adicional de {{ classData.PERCTURMACRITICA }}%
                  </span>
                </div>
                <p>
                  <strong>Início:</strong> {{ formatData(classData) }}<br />
                  <span v-if="showTime()"
                    ><strong>Horário das Aulas:</strong>
                    {{ classData.HORARIO }}</span
                  ><br />
                  <strong v-if="offer.USABO == '0'"
                    >Permite matrícula até: {{ getLimitDate(classData) }}</strong
                  >
                  <br /><span v-if="offer.USABO == '1'"
                    >* A data limite de matrícula deverá considerar as opções de
                    introdutórias disponíveis</span
                  >
                </p>
              </vs-card>
            </div>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-alert
            title="Erro ao buscar as turmas da oferta selecionada"
            class="margin"
            color="danger"
            v-if="error"
          >
            {{ error }}
          </vs-alert>
        </vs-row>
      </div>
    </div>
    <ConsultValidationMat />
  </div>
</template>

<script>
import { bus } from "../main";
import SelectedCourseBox from "../components/SelectedCourseBox.vue";
import SelectedOfferBox from "../components/SelectedOfferBox.vue";
import ConsultValidationMat from "../components/ConsultValidationMat.vue"
import { getStepsInformation, updateStepsInformation } from "../helpers/storage";
import CoursesService from "../services/courses";
import { formatDateToLocale, updateDiscussion } from "../helpers";
import moment from "moment";

export default {
  name: "Classes",
  components: {
    SelectedCourseBox,
    SelectedOfferBox,
    ConsultValidationMat
  },
  data: () => ({
    classes: [],
    error: null,
    offer: null,
  }),
  mounted() {
    this.$vs.loading({
      color: "danger",
    });
    const { offer, electives, course } = getStepsInformation();
    this.offer = offer;
    let hasElectives = [];
    let qtd = 0;
    if (electives) {
      electives.forEach((element) => {
        qtd = hasElectives.push(element.CODDISC);
      });
    }
    for (var i = qtd; i < 3; i++) {
      hasElectives.push(0);
    }
    new CoursesService()
      .getClasses(
        offer.MODALIDADE == 'D' ? 'D' : offer.TURNO == 'INTEGRAL' ? 'I' : offer.TURNO == 'MANHÃ' ? 'M' : offer.TURNO == 'TARDE' ? 'T' : 'N',
        offer.CODCURSO,
        offer.IDHABILITACAOFILIAL,
        offer.CODCAMPUS,
        offer.CODFILIAL,
        hasElectives[0],
        hasElectives[1],
        hasElectives[2],
        course.IDCLASSIFICACAO
      )
      .then(({ data }) => {
        const classes = Array.isArray(data) ? data : [data];
        this.classes = classes;
        this.$vs.loading.close();
      })
      .catch((error) => {
        if (error && error.code === "ECONNABORTED") {
          this.error = "Tempo esgotado ao consultar turmas. Tente novamente.";
        } else if (error && error.response && error.response.data && error.response.data.error) {
          this.error = error.response.data.error;
        } else {
          this.error = "Não foi possível carregar as turmas. Tente novamente.";
        }
        this.$vs.loading.close();
      });
  },
  created() {
    bus.$emit("updateSteps", 2);
  },
  methods: {
    critical(introductory) {
      if(introductory != '0.00') {
        return 'box-shadow: 0px 0px 5px 3.5px #FF0000;'
      } else {
        return 'box-shadow: 0px 0px 5px 3.5px #888888;'
      }
    },
    showTime() {
      const { offer } = getStepsInformation();
      if (offer.MODALIDADE === "D") {
        return false;
      }
      return true;
    },

    formatData({ DTINICIAL: date }) {
      return formatDateToLocale(date);
    },

    getLimitDate(classData) {
      const limitDate = moment(classData.DTINICIAL).subtract(3, "days");
      return formatDateToLocale(limitDate);
    },

    formatNomeTurma(classData) {
      return `${classData.NOMETURMA} com início em ${formatDateToLocale(
        classData.DTINICIAL
      )}`;
    },

    selectClass(classData) {
      this.$vs.loading({
        color: "danger",
      });
      updateDiscussion(`Selecionou Turma: ${this.formatNomeTurma(classData)}`, {
        classData,
      }).finally(() => {
        updateStepsInformation( classData );
        const { offer } = getStepsInformation();
        if (offer.USABO == 1) {
          this.$router.push("/introductories");
        } else {
          this.$router.push("/subjects");
        }
        this.$vs.loading.close();
      });
    },
  },
};
</script>

<style>
#select-class-page .choosable-card {
  cursor: pointer;
}

#select-class-page .choosable-card.selected {
  box-shadow: 0 0 0 1px rgb(var(--vs-primary));
  cursor: default;
}

#select-class-page .choosable-card.disabled,
#select-class-page .choosable-card.disabled:hover {
  cursor: default;
  color: #888;
  box-shadow: none;
}
</style>
